module.exports = __webpack_public_path__ + "static/design-thinking-process-809031dc0f933b35cd0b1a58fc8e41ba.mp4";